/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccessRouteImport } from './routes/access'
import { Route as EnquiriesRouteImport } from './routes/enquiries'
import { Route as ResellersRouteImport } from './routes/resellers'
import { Route as TenantsRouteImport } from './routes/tenants'
import { Route as TenantsTenantIdRouteImport } from './routes/tenants_.$tenantId'
import { Route as TenantsTenantIdCampaignsRouteImport } from './routes/tenants_.$tenantId_.campaigns'
import { Route as TenantsTenantIdDesignerRouteImport } from './routes/tenants_.$tenantId_.designer'
import { Route as TenantsTenantIdGroupsRouteImport } from './routes/tenants_.$tenantId_.groups'
import { Route as TenantsTenantIdOnboardingRouteImport } from './routes/tenants_.$tenantId_.onboarding'
import { Route as TenantsTenantIdRulesRouteImport } from './routes/tenants_.$tenantId_.rules'
import { Route as TenantsTenantIdTesterRouteImport } from './routes/tenants_.$tenantId_.tester'
import { Route as TenantsTenantIdUsersRouteImport } from './routes/tenants_.$tenantId_.users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRoute = AccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => rootRouteImport,
} as any)
const EnquiriesRoute = EnquiriesRouteImport.update({
  id: '/enquiries',
  path: '/enquiries',
  getParentRoute: () => rootRouteImport,
} as any)
const ResellersRoute = ResellersRouteImport.update({
  id: '/resellers',
  path: '/resellers',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsRoute = TenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdRoute = TenantsTenantIdRouteImport.update({
  id: '/tenants_/$tenantId',
  path: '/tenants/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdCampaignsRoute =
  TenantsTenantIdCampaignsRouteImport.update({
    id: '/tenants_/$tenantId_/campaigns',
    path: '/tenants/$tenantId/campaigns',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantsTenantIdDesignerRoute = TenantsTenantIdDesignerRouteImport.update({
  id: '/tenants_/$tenantId_/designer',
  path: '/tenants/$tenantId/designer',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdGroupsRoute = TenantsTenantIdGroupsRouteImport.update({
  id: '/tenants_/$tenantId_/groups',
  path: '/tenants/$tenantId/groups',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdOnboardingRoute =
  TenantsTenantIdOnboardingRouteImport.update({
    id: '/tenants_/$tenantId_/onboarding',
    path: '/tenants/$tenantId/onboarding',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantsTenantIdRulesRoute = TenantsTenantIdRulesRouteImport.update({
  id: '/tenants_/$tenantId_/rules',
  path: '/tenants/$tenantId/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdTesterRoute = TenantsTenantIdTesterRouteImport.update({
  id: '/tenants_/$tenantId_/tester',
  path: '/tenants/$tenantId/tester',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsTenantIdUsersRoute = TenantsTenantIdUsersRouteImport.update({
  id: '/tenants_/$tenantId_/users',
  path: '/tenants/$tenantId/users',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/enquiries': typeof EnquiriesRoute
  '/resellers': typeof ResellersRoute
  '/tenants': typeof TenantsRoute
  '/tenants/$tenantId': typeof TenantsTenantIdRoute
  '/tenants/$tenantId/campaigns': typeof TenantsTenantIdCampaignsRoute
  '/tenants/$tenantId/designer': typeof TenantsTenantIdDesignerRoute
  '/tenants/$tenantId/groups': typeof TenantsTenantIdGroupsRoute
  '/tenants/$tenantId/onboarding': typeof TenantsTenantIdOnboardingRoute
  '/tenants/$tenantId/rules': typeof TenantsTenantIdRulesRoute
  '/tenants/$tenantId/tester': typeof TenantsTenantIdTesterRoute
  '/tenants/$tenantId/users': typeof TenantsTenantIdUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/enquiries': typeof EnquiriesRoute
  '/resellers': typeof ResellersRoute
  '/tenants': typeof TenantsRoute
  '/tenants/$tenantId': typeof TenantsTenantIdRoute
  '/tenants/$tenantId/campaigns': typeof TenantsTenantIdCampaignsRoute
  '/tenants/$tenantId/designer': typeof TenantsTenantIdDesignerRoute
  '/tenants/$tenantId/groups': typeof TenantsTenantIdGroupsRoute
  '/tenants/$tenantId/onboarding': typeof TenantsTenantIdOnboardingRoute
  '/tenants/$tenantId/rules': typeof TenantsTenantIdRulesRoute
  '/tenants/$tenantId/tester': typeof TenantsTenantIdTesterRoute
  '/tenants/$tenantId/users': typeof TenantsTenantIdUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/enquiries': typeof EnquiriesRoute
  '/resellers': typeof ResellersRoute
  '/tenants': typeof TenantsRoute
  '/tenants_/$tenantId': typeof TenantsTenantIdRoute
  '/tenants_/$tenantId_/campaigns': typeof TenantsTenantIdCampaignsRoute
  '/tenants_/$tenantId_/designer': typeof TenantsTenantIdDesignerRoute
  '/tenants_/$tenantId_/groups': typeof TenantsTenantIdGroupsRoute
  '/tenants_/$tenantId_/onboarding': typeof TenantsTenantIdOnboardingRoute
  '/tenants_/$tenantId_/rules': typeof TenantsTenantIdRulesRoute
  '/tenants_/$tenantId_/tester': typeof TenantsTenantIdTesterRoute
  '/tenants_/$tenantId_/users': typeof TenantsTenantIdUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access'
    | '/enquiries'
    | '/resellers'
    | '/tenants'
    | '/tenants/$tenantId'
    | '/tenants/$tenantId/campaigns'
    | '/tenants/$tenantId/designer'
    | '/tenants/$tenantId/groups'
    | '/tenants/$tenantId/onboarding'
    | '/tenants/$tenantId/rules'
    | '/tenants/$tenantId/tester'
    | '/tenants/$tenantId/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access'
    | '/enquiries'
    | '/resellers'
    | '/tenants'
    | '/tenants/$tenantId'
    | '/tenants/$tenantId/campaigns'
    | '/tenants/$tenantId/designer'
    | '/tenants/$tenantId/groups'
    | '/tenants/$tenantId/onboarding'
    | '/tenants/$tenantId/rules'
    | '/tenants/$tenantId/tester'
    | '/tenants/$tenantId/users'
  id:
    | '__root__'
    | '/'
    | '/access'
    | '/enquiries'
    | '/resellers'
    | '/tenants'
    | '/tenants_/$tenantId'
    | '/tenants_/$tenantId_/campaigns'
    | '/tenants_/$tenantId_/designer'
    | '/tenants_/$tenantId_/groups'
    | '/tenants_/$tenantId_/onboarding'
    | '/tenants_/$tenantId_/rules'
    | '/tenants_/$tenantId_/tester'
    | '/tenants_/$tenantId_/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessRoute: typeof AccessRoute
  EnquiriesRoute: typeof EnquiriesRoute
  ResellersRoute: typeof ResellersRoute
  TenantsRoute: typeof TenantsRoute
  TenantsTenantIdRoute: typeof TenantsTenantIdRoute
  TenantsTenantIdCampaignsRoute: typeof TenantsTenantIdCampaignsRoute
  TenantsTenantIdDesignerRoute: typeof TenantsTenantIdDesignerRoute
  TenantsTenantIdGroupsRoute: typeof TenantsTenantIdGroupsRoute
  TenantsTenantIdOnboardingRoute: typeof TenantsTenantIdOnboardingRoute
  TenantsTenantIdRulesRoute: typeof TenantsTenantIdRulesRoute
  TenantsTenantIdTesterRoute: typeof TenantsTenantIdTesterRoute
  TenantsTenantIdUsersRoute: typeof TenantsTenantIdUsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access': {
      id: '/access'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof AccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enquiries': {
      id: '/enquiries'
      path: '/enquiries'
      fullPath: '/enquiries'
      preLoaderRoute: typeof EnquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resellers': {
      id: '/resellers'
      path: '/resellers'
      fullPath: '/resellers'
      preLoaderRoute: typeof ResellersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants': {
      id: '/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof TenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId': {
      id: '/tenants_/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/tenants/$tenantId'
      preLoaderRoute: typeof TenantsTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/campaigns': {
      id: '/tenants_/$tenantId_/campaigns'
      path: '/tenants/$tenantId/campaigns'
      fullPath: '/tenants/$tenantId/campaigns'
      preLoaderRoute: typeof TenantsTenantIdCampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/designer': {
      id: '/tenants_/$tenantId_/designer'
      path: '/tenants/$tenantId/designer'
      fullPath: '/tenants/$tenantId/designer'
      preLoaderRoute: typeof TenantsTenantIdDesignerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/groups': {
      id: '/tenants_/$tenantId_/groups'
      path: '/tenants/$tenantId/groups'
      fullPath: '/tenants/$tenantId/groups'
      preLoaderRoute: typeof TenantsTenantIdGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/onboarding': {
      id: '/tenants_/$tenantId_/onboarding'
      path: '/tenants/$tenantId/onboarding'
      fullPath: '/tenants/$tenantId/onboarding'
      preLoaderRoute: typeof TenantsTenantIdOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/rules': {
      id: '/tenants_/$tenantId_/rules'
      path: '/tenants/$tenantId/rules'
      fullPath: '/tenants/$tenantId/rules'
      preLoaderRoute: typeof TenantsTenantIdRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/tester': {
      id: '/tenants_/$tenantId_/tester'
      path: '/tenants/$tenantId/tester'
      fullPath: '/tenants/$tenantId/tester'
      preLoaderRoute: typeof TenantsTenantIdTesterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants_/$tenantId_/users': {
      id: '/tenants_/$tenantId_/users'
      path: '/tenants/$tenantId/users'
      fullPath: '/tenants/$tenantId/users'
      preLoaderRoute: typeof TenantsTenantIdUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRoute: AccessRoute,
  EnquiriesRoute: EnquiriesRoute,
  ResellersRoute: ResellersRoute,
  TenantsRoute: TenantsRoute,
  TenantsTenantIdRoute: TenantsTenantIdRoute,
  TenantsTenantIdCampaignsRoute: TenantsTenantIdCampaignsRoute,
  TenantsTenantIdDesignerRoute: TenantsTenantIdDesignerRoute,
  TenantsTenantIdGroupsRoute: TenantsTenantIdGroupsRoute,
  TenantsTenantIdOnboardingRoute: TenantsTenantIdOnboardingRoute,
  TenantsTenantIdRulesRoute: TenantsTenantIdRulesRoute,
  TenantsTenantIdTesterRoute: TenantsTenantIdTesterRoute,
  TenantsTenantIdUsersRoute: TenantsTenantIdUsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
